export default "__VITE_ASSET__BK4z0A5O__"